export default "__VITE_ASSET__8275deff__"